import {Theme, useMediaQuery} from '@material-ui/core'

export const useMobile = () => useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
